import { appUrl } from 'utils/wrappers';
import PageableBase from 'app/collections/pageable_base';
import Tracker from 'app/models/tracker';

export default PageableBase.extend({
  model: Tracker,
  key: 'trackers',
  url: appUrl('trackers'),

  initialize(models, { apiModeSelection, dateRange, statusSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = dateRange;
    this.statusSelection = statusSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.apiModeSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.statusSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.statusSelection.getParams(),
      ...this.dateRange.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/trackers.js